<div>
  @switch (siteBrand) {
    @case ('audibel') {
      <div class="bannerAudibel">
        {{bannerText}}
      </div>
    }
    @case ('hearcircle') {
      <div class="bannerHearCircle">
        {{bannerText}}
      </div>
    }
    @case ('kindilink3') {
      <div class="bannerKIND">
        {{bannerText}}
      </div>
    }
    @case ('nuear') {
      <div class="bannerNuear">
        {{bannerText}}
      </div>
    }
    @case ('audiosync') {
      <div class="bannerAudiosync">
        {{bannerText}}
      </div>
    }
    @case ('soundgear') {
      <div class="bannerSoundGear">
        {{bannerText}}
      </div>
    }
    @case ('phantom') {
      <div class="bannerSoundGear">
        {{bannerText}}
      </div>
    }
    @case ('afflelou') {
      <div class="bannerAfflelou">
        {{bannerText}}
      </div>
    }
    @case ('ouiezen') {
      <div class="bannerOuiezen">
        {{bannerText}}
      </div>
    }
    @case ('starkey') {
      <div class="banner">
        {{bannerText}}
      </div>
    }
    @default {
      <div>
      </div>
    }
  }
</div>
